import createCustomization from './createCustomization';

export default createCustomization();


/** WEBPACK FOOTER **
 ** ./src/app/customization/index.js
 **/